import ShopIdContextProvider from "context/orderFormContexts/ShopIdContext"
import { useUser } from "hooks/firestore/simple/useUser"
import { ReactNode, useMemo } from "react"

type AdminShopIdContextProviderProps = {
  children?: ReactNode
}

export const AdminShopIdContextProvider = ({ children }: AdminShopIdContextProviderProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const user = useUser()
  const shopId = user?.currentRestaurant
  return useMemo(() => {
    return <ShopIdContextProvider shopId={shopId}>{children}</ShopIdContextProvider>
  }, [shopId, children])
}
